import type { IJsonModel } from 'flexlayout-react';

export const settingOptionsModelJson: IJsonModel = {
    global: {
        tabEnableClose: false,
        tabSetEnableSingleTabStretch: true,
        tabSetEnableMaximize: false,
        tabSetEnableDrop: false,
        tabEnableDrag: false,
        tabEnableRename: false,
        tabClassName: 'cursor-default',
    },
    layout: {
        weight: 100,
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        weight: 65,
                        id: 'options-tab',
                        children: [
                            {
                                type: 'tab',
                                name: '',
                                component: 'settingOptions',

                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        weight: 35,
                        id: 'preview-tab',
                        children: [
                            {
                                type: 'tab',
                                name: '',
                                component: 'articlePreview',
                            },
                        ],
                    },
                ],
            },
        ],
    },
};